import { render, staticRenderFns } from "./ManageCustomers.vue?vue&type=template&id=117a0eec"
import script from "./ManageCustomers.vue?vue&type=script&lang=ts"
export * from "./ManageCustomers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports